import type { CSSProperties } from "react";

/**
 * Il pallino che porta la tinta di un gruppo.
 *
 * La tinta si sceglie creando il gruppo, e questa è l'unica cosa che la mostra
 * ora che le card sono bianche. Usa le **tinte forti**: i wash pastello del
 * design system funzionano su una superficie grande, e a dieci pixel non si
 * vedrebbero.
 */
export const GROUP_TINTS = ["lavender", "grey", "sky", "sand", "blush", "mint"] as const;

export type GroupTintName = (typeof GROUP_TINTS)[number];

export function groupTintColor(tint: string): string {
  return (GROUP_TINTS as readonly string[]).includes(tint)
    ? `var(--tint-${tint}-strong)`
    : "var(--tint-grey-strong)";
}

export interface GroupTintDotProps {
  tint: string;
  size?: number;
  style?: CSSProperties;
}

export function GroupTintDot({ tint, size = 10, style }: GroupTintDotProps) {
  return (
    <span
      aria-hidden="true"
      style={{
        width: size,
        height: size,
        flexShrink: 0,
        borderRadius: "var(--radius-pill)",
        background: groupTintColor(tint),
        ...style,
      }}
    />
  );
}
